import { render, staticRenderFns } from "./AdminAddBusCompanyPriceModal.vue?vue&type=template&id=3b124d2e&"
import script from "./AdminAddBusCompanyPriceModal.vue?vue&type=script&lang=js&"
export * from "./AdminAddBusCompanyPriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports